import { IParentEntity } from 'app/shared/interfaces/entity';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Subject } from '../../../shared/models/subject';
import { NoteDialogComponent } from '../../content/notes/note-dialog/note-dialog.component';
import { fuseAnimations } from '@fuse/animations';
import { Note, NoteType } from 'app/shared/models/note';
import { Router } from '@angular/router';
import { NoteService } from 'app/shared/services/note.service';
import { SubjectNote } from 'app/shared/models/subject-note';
import { TaskNote } from 'app/shared/models/task-note';
import { Subscription } from 'rxjs';
import { AuthService } from 'app/shared/services/auth.service';
import { NoteTypeService } from 'app/shared/services/note-type.service';
import { DefaultDataService } from 'app/shared/services/default-data.service';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'note-widget',
  templateUrl: './note-widget.component.html',
  styleUrls: ['./note-widget.component.scss'],
  animations: fuseAnimations,
  encapsulation: ViewEncapsulation.None,
})
export class NoteWidgetComponent implements OnInit, OnDestroy {
  title: string;
  parent: IParentEntity;
  displayPage = false;
  noteOrderAscending = false;
  allowEdit = false;
  userReadOnly = false;
  noteTypes: NoteType[] = [];
  noteTypesList: NoteType[] = [];
  onNotesChanged: Subscription;
  subjectTypeId: number = -1;
  isLoading: boolean = false;
  numberofNotes: number;

  showNoteTypeFilter: boolean = false;

  @Input() set subject(val: Subject) {
    this.isLoading = true;
    if (val) {
      const p = val;
      this.parent = {
        id: p.id,
        uid: p.uid,
        type: p.isReferral ? 'referral' : 'subject',
        summary: p.summary,
      };
      this.allowEdit = this.parent.uid && !val.archived && !this.userReadOnly;
      this.subjectTypeId = p.subjectTypeId;
      this.noteService
        .getNotesByType(this.parent, 'all')
        .then(() => (this.isLoading = false));
      if (this.noteTypesList && this.noteTypesList.length > 0) {
        this.updateNoteTypes();
      }
    }
  }

  // the following are not needed but cause silent errors if not present
  @Input() id: number;
  @Input() subjectId: number;
  @Input() processTypeId: number;
  @Input() settings: any;

  constructor(
    public dialog: MatDialog,
    private defaultData: DefaultDataService,
    private router: Router,
    private noteService: NoteService,
    private noteTypeService: NoteTypeService,
    private authService: AuthService
  ) {
    this.title = 'Notes';
    this.noteOrderAscending = this.noteService.noteOrderAscending;
    this.userReadOnly = this.authService.isUserReadOnly();
  }

  updateNoteTypes() {
    this.noteTypes = [];
    this.noteTypes.push(new NoteType({ id: -1, name: 'All', selected: true }));
    this.noteTypes.push(new NoteType({ id: 0, name: 'Blank', selected: true }));
    this.showNoteTypeFilter = false;
    if (this.noteTypesList) {
      this.noteTypesList.forEach((i) => {
        i.selected = true;
        if (
          i.subjectTypeId == undefined ||
          i.subjectTypeId == -1 ||
          i.subjectTypeId == this.subjectTypeId
        ) {
          if (i.hideRecord == undefined || i.hideRecord === false) {
            this.noteTypes.push(i);
            this.showNoteTypeFilter = true;
          }
        }
      });
    }
    this.noteService.setNoteTypeFilter(
      this.noteTypes.filter((i) => i.selected === true)
    );
    this.noteService.getNotes(this.parent);
  }

  applyNoteTypeFilter(noteType: NoteType) {
    // Update selected Note Type filter
    noteType.selected = !noteType.selected;

    // If changing 'All' note type then set all note types on or off.
    if (noteType.id == -1) {
      this.noteTypes.forEach((i) => (i.selected = noteType.selected));
    } else {
      // Check to see if all note types selected or not and update 'All' note type.
      var c1 = this.noteTypes.filter((i) => i.id != -1);
      var c2 = c1.filter((i) => i.selected === true);
      var all = this.noteTypes.find((i) => i.id == -1);
      if (all) all.selected = c1.length === c2.length;
    }

    // Update notes list
    if (this.showNoteTypeFilter == true) {
      this.noteService.setNoteTypeFilter(
        this.noteTypes.filter((i) => i.selected === true)
      );
      this.noteService.getNotes(this.parent);
    }
  }

  ngOnInit() {
    if (
      this.defaultData.enableNotesAsPage &&
      this.defaultData.enableNotesAsPage == true
    ) {
      this.displayPage = this.defaultData.enableNotesAsPage;
    }

    this.onNotesChanged = this.noteService.onNotesChanged.subscribe((notes) => {
      let notes2 = this.noteService.ApplyNoteTypeFilter(notes);
      // this.title =
      //   'Notes ' +
      //   (notes2 && notes2.length > 0 ? '(' + notes2.length + ')' : '');
      this.numberofNotes = notes2.length ? notes2.length : 0;
    });

    this.noteTypeService.getAllData().subscribe((d) => {
      this.noteTypesList = d.sort((a, b) => a.name.localeCompare(b.name));
      this.updateNoteTypes();
    });
  }

  ngOnDestroy() {
    this.onNotesChanged?.unsubscribe();
  }

  add() {
    this.dialog.open(NoteDialogComponent, {
      data: {
        note:
          this.parent.type.toLowerCase() === 'task'
            ? new TaskNote(this.parent.id, new Note())
            : new SubjectNote(this.parent.id, new Note()),
        parent: this.parent,
        readOnly: false,
      },
      disableClose: true,
      autoFocus: false,
    });
  }

  displayAsPage(displayPage) {
    this.displayPage = displayPage;
  }

  setNoteOrder(noteOrderAscending) {
    if (this.noteService.noteOrderAscending !== noteOrderAscending) {
      this.noteService.toggleNotesOrder(this.parent);
    }
    this.noteOrderAscending = noteOrderAscending;
  }

  openNoteManager(event) {
    this.router.navigateByUrl(
      `notes/${this.parent.type}/${this.parent.uid}/notetype/all`
    );
  }
}
